var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 17.5a.63.63 0 0 1-.625.625H2.917a1.042 1.042 0 0 1-1.042-1.042V2.5a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v14.375H17.5a.63.63 0 0 1 .625.625ZM5 12.925c.15 0 .3-.05.417-.158l2.875-2.6 2.833 2.6c.242.216.6.216.842 0l4.075-3.659v.25a.63.63 0 0 0 .625.625.63.63 0 0 0 .625-.625V7.692c0-.042-.017-.084-.025-.125 0-.025 0-.05-.017-.075a.61.61 0 0 0-.583-.425H15a.63.63 0 0 0-.625.625.63.63 0 0 0 .625.625h.05l-3.5 3.141-2.833-2.6a.626.626 0 0 0-.842 0l-3.292 2.984a.622.622 0 0 0-.041.883.64.64 0 0 0 .466.208L5 12.925Z",
    fill: "current"
  })));
};
export default SvgAnalytics;